module.exports = __webpack_public_path__ + "images/projects/p++-featured.jpg";